<template>
  <div class="bannerBox">
    <a-carousel :dot-position="bottom">
      <div>
        <img class="bannerImg" src="@/assets/img/scjr-jrcp.jpg" />
      </div>
    </a-carousel>
  </div>
  <div class="menuContentBox">
    <div style="width: 100%;background-color: #fff;">
  
  <router-view/>
  </div>
  </div>
</template>
<script>
export default {
  name: 'investor',
  props: {
  },
  mounted() {
    this.title = this.$route.query.type
  },
  data() {
    return {
      title:''
    }
  },
	methods: {
		goMore(url,key) {
      this.$router.push({
				path: url,
				query: { type: key }
			})
      this.$parent.$parent.clearHeadFun()
		},
		backhome() {
      this.goMore('/finance/index','首页')
		}
	}
}
</script>
<style scoped lang="less">
@import "../../css/components.less";
.bannerBox {
  position: relative;
  width: 100%;
  //margin-bottom: 20px;

  .bannerImg {
    width: 100%;
    height: 100%;
  }
}
</style>